export default "__VITE_ASSET__DOLFBdVL__"